var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-lazy-loading"},[(_vm.enableClientOnly)?[_c('client-only',[(_vm.loaded)?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.loading && _vm.mounted)?_vm._t("css-skeleton"):_vm._e()],2)]:[(_vm.loaded)?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.loading)?_vm._t("css-skeleton"):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }